import * as React from 'react';
import type { ICategoryHeaderProps } from '../category-header';
import s from './category-header-mobile.scss';
import { Text, Heading } from '@wix/design-system';
import { SubCategoriesSelectorMobile } from './sub-categories-selector-mobile';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { composer } from '../../../component-decorators/composer';
import { BackButton } from '../../back-button';

export interface ICategoryHeaderMobileProps
  extends ICategoryHeaderProps,
    Partial<WithTranslationProps> {
  shouldShowBackButton?: boolean;
}

export const CategoryHeaderMobile = composer()
  .withTranslation()
  .compose(
    ({
      name,
      description,
      slug,
      subCategoriesSelectorProps,
      shouldShowBackButton,
      t,
    }: ICategoryHeaderMobileProps) => {
      const isSalePage = slug === 'holiday-sale';
      return (
        <div data-testid="category-header-mobile" className={s.categoryHeader}>
          {shouldShowBackButton && <BackButton skinColor="light" />}
          <Heading
            className={s.categoryHeaderName}
            appearance="H1"
            light={true}
            dataHook="category-header-mobile-name"
          >
            {isSalePage ? t('home.holidaySale.title-2022') : name}
          </Heading>
          <Text
            size="medium"
            weight="normal"
            light={true}
            dataHook="category-header-mobile-description"
          >
            {isSalePage
              ? t('category.holidaySale.second-title-2022')
              : description}
          </Text>
          {!isSalePage && (
            <SubCategoriesSelectorMobile {...subCategoriesSelectorProps} />
          )}
        </div>
      );
    },
  );
